import React, { FC } from 'react';
import SiteCard from './SiteCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SiteDesign } from '../../../shared/types/site/design';
import { useQueryParam } from '../../../common/hooks/use-query-param';
import { MODAL } from '../../../constants';
import ActionModal, { ActionType } from './modal/ActionModal';
import { useHistory } from 'react-router';
import ShareModal from './modal/ShareModal';
import SiteSettingModal from '../../site-settings/SiteSettingsModal';
import { Account } from '../../../shared/types/account';
import DeleteSiteModal from '../../site-settings/modal/DeleteSiteModal';
import client from '../../../common/apollo/client';

interface SiteSlideProps {
    siteDesign: SiteDesign;
    account: Account;
}
const SiteSlide: FC<SiteSlideProps> = ({ siteDesign, account }) => {
    const [modal, setModal] = useQueryParam<string | null>('modal');
    const history = useHistory();

    const handleClickEditSite = () => {
        if (siteDesign) {
            history.push(`/account/${siteDesign.accountId}/site-design`);
        } else {
            history.push(`/account/${account.id}/select-theme`);
        }
    };

    const handleActionClick = (action: ActionType) => {
        switch (action) {
            case ActionType.EDIT:
                setModal('');
                handleClickEditSite();
                break;
            case ActionType.DELETE:
                setModal(MODAL.SITE_DELETE);
                break;
            case ActionType.SETTING:
                setModal(MODAL.SITE_SETTING);
                break;
            case ActionType.SHARE:
                setModal(MODAL.SITE_SHARE);
                break;
            case ActionType.PREVIEW:
                setModal('');
                history.push(`/account/${account.id}/site-design?mode=PREVIEW`);
                break;
        }
    };
    return (
        <div className={`mb-20 swipe-h-auto`}>
            <Swiper
                observer={true}
                initialSlide={0}
                spaceBetween={14}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 2.5,
                    },
                    '@0.3': {
                        slidesPerView: 2.5,
                    },
                    '@0.5': {
                        slidesPerView: 2.5,
                    },
                    '@0.8': {
                        slidesPerView: 3,
                    },
                    '@1.10': {
                        slidesPerView: 4,
                    },
                    '@1.3': {
                        slidesPerView: 5,
                    },
                    '@1.50': {
                        slidesPerView: 6,
                    },
                    '@1.75': {
                        slidesPerView: 7,
                    },
                    '@2': {
                        slidesPerView: 8,
                    },
                }}
            >
                <SwiperSlide className={'h-150'}>
                    <SiteCard
                        siteDesign={siteDesign}
                        onClickMoreAction={() => {
                            setModal(MODAL.SITE_ACTION);
                        }}
                        onClickThumbnail={handleClickEditSite}
                        showActions={true}
                    />
                </SwiperSlide>
            </Swiper>
            <ActionModal
                open={modal === MODAL.SITE_ACTION}
                onClose={() => {
                    setModal('');
                }}
                onActionClick={handleActionClick}
            />
            <ShareModal
                open={modal === MODAL.SITE_SHARE}
                onClose={() => {
                    setModal('');
                }}
                name={siteDesign.name}
                url={`https://${process.env.REACT_APP_LIVE_BIO_DOMAIN}/${siteDesign.path}`}
            />
            <SiteSettingModal
                open={modal === MODAL.SITE_SETTING}
                onClose={() => {
                    setModal('');
                }}
                account={account}
                design={siteDesign}
            />
            <DeleteSiteModal
                title="Delete Site"
                open={modal === MODAL.SITE_DELETE}
                onClose={() => setModal(null)}
                showClose={true}
                onSuccess={() => {
                    client.refetchQueries({
                        include: ['GetAccount'],
                    });
                }}
            />
        </div>
    );
};
export default SiteSlide;
